import { CommonCodeCategory } from 'interfaces/common';
import { storeClient } from './apiClients';

// 공통코드 트리 조회 — 서버가 '사용중'인 카테고리와 하위 코드만 내려줌
export const getCommonCodes = async (): Promise<CommonCodeCategory[]> => {
  const { data } = await storeClient.get('/common/codes');
  return data;
};
